import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import toastMessages from "src/constant/toastMessages.json";
import { GetError } from "src/constant";
import { VerifyOtp, sendEmailOtp } from "src/thunks/auth";
import { AuthenticationWrawper } from "src/components/AuthenticationWrawper";

const OTP = () => {

  /** redux store useDispatch & useSelector ------------------------------ **/
  const navigate = useNavigate();
  const dispatch = useDispatch();

  /** hooks useState ----------------------------------------------------- **/
  const [timeLeft, setTimeLeft] = useState(30);
  const [otpData, _otpData] = useState({
    value: "",
    otp1: "",
    otp2: "",
    otp3: "",
    otp4: "",
    otp5: "",
    disable: true,
  });

  /** hooks useEffect----------------------------------------------------- **/

  useEffect(() => {
    let interval = null;
    if (timeLeft > 0) {
      interval = setInterval(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timeLeft]);

  /** handler functions--------------------------------------------------- **/

  /** Fnction executes when click on go back from OTP screen ------------------**/
  const handleBackButtonClickFromOtp = () => {
    navigate("/login");
  };

  /** Function execute when change one of the OTP field value ------------------ **/
  const handleChange = (value1, event) => {
    _otpData({
      ...otpData,
      [value1]: event.target.value,
    });
  };

  /** Function executes when inputFocus on the OTP fields ------------------ **/
  const inputfocus = (elmnt) => {
    if (elmnt.key === "Delete" || elmnt.key === "Backspace") {
      const next = elmnt.target.tabIndex - 2;
      if (next > -1) {
        elmnt.target.form.elements[next].focus();
      }
    } else {
      const next = elmnt.target.tabIndex;
      if (next < 4) {
        elmnt.target.form.elements[next].focus();
      }
    }
  };

  /** Function executes to resend the OTP ------------------ **/
  const handleResendOtp = async () => {
    try {
      let res = await dispatch(sendEmailOtp({ email: localStorage.getItem("email") })).unwrap();
      if (res) {
        toast.success(toastMessages.otpSend);
        setTimeLeft(30);
      }
    } catch (error) {
      toast.error(GetError(error?.response?.data?.errors) || "something issue");
    }

  }

  /** Function executes when submit entered OTP ------------------ **/
  const handleSubmitOtp = async () => {
    try {
      const finalOtp = otpData?.otp1 + otpData?.otp2 + otpData?.otp3 + otpData?.otp4;
      const res = await dispatch(VerifyOtp({ email: localStorage.getItem("email"), otp: finalOtp })).unwrap();
      if (res) {
        navigate("/resetpassword")
        setTimeLeft(30);
      }
    } catch (error) {
      toast.error(GetError(error?.response?.data?.errors) || "something issue");
    }
  }

  return (
    <AuthenticationWrawper>
      <div className="otpHeading">
        <div>4-digit OTP has been sent to </div>
        <b>{localStorage.getItem("email")}</b>
      </div>
      <div className="otpName">
        <span>Enter OTP</span>
      </div>
      <div className="inputFormMain">
        <form>
          <input
            name="otp1"
            type="text"
            autoComplete="off"
            className="otpInput"
            value={otpData.otp1}
            onChange={(e) => handleChange("otp1", e)}
            tabIndex="1"
            maxLength="1"
            onKeyUp={(e) => inputfocus(e)}
          />
          <input
            name="otp2"
            type="text"
            autoComplete="off"
            className="otpInput"
            value={otpData.otp2}
            onChange={(e) => handleChange("otp2", e)}
            tabIndex="2"
            maxLength="1"
            onKeyUp={(e) => inputfocus(e)}
          />
          <input
            name="otp3"
            type="text"
            autoComplete="off"
            className="otpInput"
            value={otpData.otp3}
            onChange={(e) => handleChange("otp3", e)}
            tabIndex="3"
            maxLength="1"
            onKeyUp={(e) => inputfocus(e)}
          />
          <input
            name="otp4"
            type="text"
            autoComplete="off"
            className="otpInput"
            value={otpData.otp4}
            onChange={(e) => handleChange("otp4", e)}
            tabIndex="4"
            maxLength="1"
            onKeyUp={(e) => inputfocus(e)}
          />
        </form>
      </div>
      <div className="resendOtpContainer">
        {timeLeft == 0 ?
          <span style={{ color: "blue", cursor: "pointer" }} onClick={() => handleResendOtp()}>Resend OTP</span> :
          <span>Resend OTP ({timeLeft})</span>}
      </div>
      <div className="spanmessagenotification">
        <span>Don't forgot to check you SPAM folder</span>
      </div>
      <div className="d-flex flex-row justify-content-between btMainContainer">
        <div className="d-flex flex-column backbuttonMainConatiner">
          <button
            className="d-flex justify-content-center align-items-center"
            type="submit"
            onClick={handleBackButtonClickFromOtp}
          >
            <i className="bi bi-arrow-left-short arrow-size-for-login"></i>
            BACK
          </button>
          <div className="d-flex justify-content-start">
            <i className="bi bi-caret-right-fill fold-back-button-styling"></i>
          </div>
        </div>
        <div className="d-flex flex-column btnresetPasswordcontainer">
          <button
            className="d-flex justify-content-center align-items-center"
            type="submit"
            onClick={() => handleSubmitOtp()}
          >
            RESET PASSWORD
            <i className="bi bi-key-fill"></i>
          </button>
          <div className="d-flex justify-content-end">
            <i className="bi bi-caret-right-fill fold-button-styling"></i>
          </div>
        </div>
      </div>
    </AuthenticationWrawper>
  );
};

export default OTP;
